<template>
  <div
    class="tag-warp"
    :style="{
      display: 'grid',
      'grid-template-columns': `repeat(${count}, ${100 / count}%)`,
    }"
  >
    <el-tag
      class="tag"
      type="warning"
      effect="plain"
      size="medium"
      v-for="r in list"
      :key="r"
    >
      {{ r }}
    </el-tag>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      default: function () {
        return [];
      },
    },
    type: {
      default: "pc",
    },
  },
  computed: {
    count() {
      if (this.type == "pc") {
        return 6;
      } else {
        return 3;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-warp {
  .tag {
    // font-size: 14px;
    text-align: center;
    margin: 5px;
  }
}
</style>